
const firebaseConfig = {
  apiKey: "AIzaSyCMgIc7I-1zaNf_vihhLYmQi34JHD7IliE",
  authDomain: "ema-john-payment-getway.firebaseapp.com",
  databaseURL: "https://ema-john-payment-getway.firebaseio.com",
  projectId: "ema-john-payment-getway",
  storageBucket: "ema-john-payment-getway.appspot.com",
  messagingSenderId: "591535815965",
  appId: "1:591535815965:web:dbc5903b13f7727a8bb5f4"
};

export default firebaseConfig ;